// Registration guard
// ──────────────────────────────────────────────────────────────────
// During school registration there is a short window where a Supabase Auth
// session exists but the matching `users` profile row does not yet. Two parts
// of the app react badly to that state:
//
//   1. App.tsx's PublicRoute sees `user` and redirects away from /register,
//      destroying the credentials screen before the principal can copy their
//      username.
//   2. AuthContext treats "session with no profile" as a broken account and
//      signs it out — which would kill the very session we need in order to
//      write the profile row.
//
// This flag tells both of them to stand down until registration finishes.
//
// It lives in sessionStorage rather than React state on purpose: PublicRoute
// needs to read it synchronously during render, it must survive a reload in
// the same tab, and it must NOT leak into other tabs or outlive the tab.
const KEY = 'septa_registration_in_progress';

export function beginRegistration(): void {
  try { sessionStorage.setItem(KEY, '1'); } catch {}
}

export function endRegistration(): void {
  try { sessionStorage.removeItem(KEY); } catch {}
}

export function isRegistering(): boolean {
  try { return sessionStorage.getItem(KEY) === '1'; } catch { return false; }
}
